import App from '../stores/app.js'

export default window.customElements.define(
  'content-with-dialog',
  class extends CustomElement {
    constructor() {
      console.log('constructed content-with-dialog modal')

      super()

      this.events = {
        ...this.events,
        'click .js-content-with-dialog-open': 'onClickOpen',
        'click .js-content-with-dialog-close': 'onClickClose'
      }
    }

    connectedCallback() {
      super.connectedCallback()
      this.$dialog = this.querySelector('dialog')
      this._onCloseDialog = this.onCloseDialog.bind(this)
      this.$dialog.addEventListener('close', this._onCloseDialog)
      console.log('connected content-with-dialog modal')
    }

    disconnectedCallback() {
      super.disconnectedCallback()
      console.log('disconnected content-with-dialog modal')
    }

    onClickOpen(e) {
      console.log('open modal clicked')
      e.preventDefault()
      App.lenis.stop()
      this.$dialog.showModal()
      setTimeout(() => {
        this.$dialog.classList.add('is-active')
      }, 10)
    }

    onClickClose() {
      console.log('close modal clicked')
      this.$dialog.classList.remove('is-active')
      setTimeout(() => {
        this.$dialog.close()
      }, 900)
    }

    onCloseDialog() {
      console.log('modal closed callback')
      App.lenis.start()
    }
  }
)
